import { render, staticRenderFns } from "./supervisor.vue?vue&type=template&id=5978f1c8&scoped=true"
import script from "./supervisor.vue?vue&type=script&lang=js"
export * from "./supervisor.vue?vue&type=script&lang=js"
import style0 from "./supervisor.vue?vue&type=style&index=0&id=5978f1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978f1c8",
  null
  
)

export default component.exports